query PageView {
  blogModule(moduleCode: "pavbloglatest.58") {
    author
    authorImage
    created
    description
    id
    image
    title
    videoCode
  }
  couponProductModules {
    dateEnd
    id
    status
    template
    products {
      currencyId
      days
      id
      image
      keyword
      model
      name
      nights
      operatorNames
      isTripToGoTour
      recommend
      cities {
        name
      }
      tags {
        id
        image
        name
      }
      packagePrice {
        finalPrice {
          hasDiscount
          amount {
            rawValue
            value
          }
          discount {
            type
          }
        }
        salePrice {
          hasDiscount
          amount {
            rawValue
            value
          }
          discount {
            type
          }
        }
      }
      tourPrice {
        finalPrice {
          hasDiscount
          amount {
            rawValue
            value
          }
          discount {
            type
          }
        }
        salePrice {
          hasDiscount
          amount {
            rawValue
            value
          }
          discount {
            type
          }
        }
      }
    }
  }
  hotProductModules(moduleCodes: ["hot.105", "hot.187", "recommend.103"]) {
    code
    categories {
      id
      keyword
      name
      sortOrder
      products {
        currencyId
        days
        id
        image
        keyword
        model
        name
        nights
        operatorNames
        isTripToGoTour
        recommend
        cities {
          name
        }
        tags {
          id
          image
          name
        }
        packagePrice {
          finalPrice {
            hasDiscount
            amount {
              rawValue
              value
            }
            discount {
              type
            }
          }
          salePrice {
            hasDiscount
            amount {
              rawValue
              value
            }
            discount {
              type
            }
          }
        }
        tourPrice {
          finalPrice {
            hasDiscount
            amount {
              rawValue
              value
            }
            discount {
              type
            }
          }
          salePrice {
            hasDiscount
            amount {
              rawValue
              value
            }
            discount {
              type
            }
          }
        }
      }
    }
  }
}
